<div class="overflow-auto"> <!--[ngClass]="selectedMenu === 'Projekte' ? 'project-height-calc' : 'route-station-height-calc'-->
    <div *ngIf="selectedMenu === 'Projekte'" class="menu-project-container h-100">

        <div *ngFor="let project of filteredProjects">
            <div [ngClass]="selection?.type === 'Projekte' && selection?.id === project.id ? 'selected' : ''">
                <img class="me-2 img" height="18px" src="../../../assets/icons/folder-tree-solid-full.svg"
                    alt="folder icon">
                <span
                    (click)="onSelectionChange({type: 'Projekte', id: project.id, name: project.name, timezoneId: project.timezoneId})"
                    class="fw-semibold selection-object">{{ project.name }}</span>
            </div>
            <div *ngFor="let group of project.groups" class="group-box">
                <div [ngClass]="selection?.type === 'group' && selection?.id === group.id ? 'selected' : ''">
                    <img class="me-2 img" height="18px" src="../../../assets/icons/folder-solid.svg" alt="folder icon">
                    <span
                        (click)="onSelectionChange({type: 'group', id: group.id, name: group.name, timezoneId: project.timezoneId})"
                        class="selection-object"> {{
                        group.name}}</span>
                </div>
            </div>
        </div>
        
    </div>
    <div *ngIf="selectedMenu === 'RouteStations'">
        RouteStations
        <div *ngFor="let routeStation of filteredRouteStations">
            <div
                [ngClass]="selection?.type === 'RouteStations' && selection?.id === routeStation.samId ? 'selected' : ''">
                <img class="me-2 img" height="18px" src="../../../assets/icons/map-pin-solid.svg" alt="folder icon">
                <span
                    (click)="onSelectionChange({type: 'RouteStations', id: routeStation.samId, name: routeStation.name, timezoneId: getTimezoneIdForRouteStation(routeStation)})"
                    class="fw-semibold selection-object">{{ routeStation.name }} - </span> <i> {{
                    isInGroup(routeStation)}} </i>
            </div>
        </div>
    </div>

    <div *ngIf="selectedMenu === 'RouteStation'" class="menu-station-container">
        <h2>Station auswählen</h2>
    </div>
</div>